import { useEffect, useState } from 'react';
import AUX from '../../../../hoc/Aux_';
import moment from 'moment';
import ActivityAddModel from './ActivityAddModel';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMonitoringDailyActivity,
  getMonitoringMember,
  getProjects,
} from '../../../../redux/MainAction';
import KeyPressModal from './KeyPressModal';
import AppsModals from './AppsModals';
import TimeTrackingCard from '../Screenshot/TimeTrackingCard';
import MapModal from './MapModal';
import AppsUsages from './AppUsages';
import PageLoader from '../../../../components/HOC/PageLoader';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { getExeVersions } from '../../../../Constant';
import VersionSelector from '../../../VersionManagement/version-selector';

const DailyActivity = () => {
  const dispatch = useDispatch();

  const member = useSelector((state) => state.Webtracker.monitoringMember);
  const project = useSelector((state) => state.Webtracker.projects);

  const [version, setVersion] = useState(getExeVersions()[0]?.value);

  useEffect(() => {
    dispatch(
      getMonitoringMember({
        offset: 0,
        limit: 100,
      })
    );

    dispatch(getProjects());
  }, []);

  return (
    <DailyActivityVersion
      key={version}
      version={version}
      member={member}
      project={project}
    >
      <VersionSelector version={version} setVersion={setVersion} />
    </DailyActivityVersion>
  );
};

const DailyActivityVersion = ({ version, children, member, project }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [apiCalls, setApiCalls] = useState(false);
  const [showReset, setShowReset] = useState(false);

  const activity = useSelector(
    (state) => state.Webtracker.monitoringDailyActivity
  );

  const summary = activity && activity?.summary;

  const [emp, setEmp] = useState([]);
  const [proj, setProj] = useState([]);
  const [keysPress, setKeyPress] = useState('no data');
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isAppUsageOpen, setIsAppUsageOpen] = useState(false);
  const [appsData, setAppsData] = useState([]);

  const date = new Date();

  const [filts, setFilts] = useState({
    employeeId: '',
    projectId: '',
    date: moment(date).format('YYYY-MM-DD'),
    groupBy: 'MINUTE',
  });

  useEffect(() => {
    if (member && member?.rows) {
      setEmp(member?.rows);
    }
    if (project && project?.rows) {
      setProj(project?.rows);
    }
  }, [member, project]);

  const onChangeFilters = (e) => {
    const { name, value } = e.target;
    setFilts({ ...filts, [name]: value });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleApply = async (e) => {
    e.preventDefault();

    if (!filts?.employeeId) {
      toast.error('Please select at member to see the activity');
      return;
    }

    setIsLoading(true);
    setApiCalls(true);

    const data = {
      employeeId: filts?.employeeId,
      date: moment(filts?.date).format('YYYY-MM-DD'),
      groupBy: filts?.groupBy,
    };

    if (filts?.projectId) {
      data.projectId = filts?.projectId;
    }

    await dispatch(getMonitoringDailyActivity(data, version === '1.1.8'));
    setShowReset(true);
    setIsLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();

    const resetFilters = {
      employeeId: '',
      projectId: '',
      date: moment(date).format('YYYY-MM-DD'),
      groupBy: 'MINUTE',
    };

    setFilts(resetFilters);
    setShowReset(false);
    setApiCalls(false);
  };

  // Modal

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  const toggleModal1 = () => {
    setIsModalOpen1(!isModalOpen1);
  };

  const handleData = (data) => {
    setKeyPress(data);
    toggleModal1();
  };

  const toggleModalEdit = (data) => {
    const findUser = emp?.filter(
      (emp) => emp?.user?.id === data?.employeeId
    )[0];
    const allData = {
      ...data,
      employee: findUser?.user,
    };
    setIsEditOpen(!isEditOpen);
    setAppsData(allData);
  };

  const toggleModalAppUsage = (data) => {
    const findUser = emp?.filter(
      (emp) => emp?.user?.id === data?.employeeId
    )[0];
    const allData = {
      ...data,
      employee: findUser?.user,
    };
    setIsAppUsageOpen(!isAppUsageOpen);
    setAppsData(allData);
  };

  return (
    <PageLoader isLoading={isLoading}>
      <AUX>
        <div className="page-content-wrapper">
          <div className="col-12 d-flex align-items-center mb-2 ">
            <h5 className="text-muted col-4"></h5>
            <div
              className="col-8 d-flex justify-content-end align-items-center"
              style={{ gap: '20px' }}
            >
              {/* <Link to='/time-request' ><span className='text-dark' style={{cursor:'pointer'}}>See Time Requests</span></Link> */}
              {/* <Button
              className=""
              size="sm"
              color="dark"
              onClick={toggleModal}
            >
              + Add Time
            </Button> */}
            </div>
          </div>
          <ActivityAddModel open={isModalOpen} onClose={toggleModal} />
          <KeyPressModal
            open={isModalOpen1}
            onClose={toggleModal1}
            keysData={keysPress}
          />
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-12">
                    <div className="card m-b-10">
                      <div className="card-body">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ gap: '10px' }}
                        >
                          <div
                            className="d-flex justify-content-start align-items-center"
                            style={{ gap: '10px' }}
                          >
                            {children}

                            <select
                              className="form-control font-16"
                              style={{
                                maxWidth: '215px',
                                cursor: 'pointer',
                                minWidth: '170px',
                              }}
                              name="employeeId"
                              value={filts?.employeeId}
                              onChange={onChangeFilters}
                            >
                              <option value="">--Select Member--</option>
                              {emp?.map((employee, idx) => (
                                <option key={idx} value={employee?.user?.id}>
                                  {employee?.user?.firstName}{' '}
                                  {employee?.user?.lastName}
                                </option>
                              ))}
                            </select>

                            <select
                              className="form-control font-16"
                              style={{
                                maxWidth: '215px',
                                cursor: 'pointer',
                                minWidth: '170px',
                              }}
                              name="projectId"
                              value={filts?.projectId || ''}
                              onChange={onChangeFilters}
                            >
                              <option value="">--Select Project--</option>
                              {proj?.map((prj, idx) => (
                                <option key={idx} value={prj?.id}>
                                  {prj?.name}
                                </option>
                              ))}
                            </select>

                            <input
                              type="date"
                              className="form-control font-16"
                              id="username2"
                              name="date"
                              value={filts?.date}
                              onChange={onChangeFilters}
                              style={{ maxWidth: '160px' }}
                            />

                            <select
                              className="form-control font-16"
                              style={{ maxWidth: '140px', cursor: 'pointer' }}
                              name="groupBy"
                              value={filts?.groupBy}
                              onChange={onChangeFilters}
                            >
                              <option value="MINUTE">Minute</option>
                              <option value="TIME">Time</option>
                            </select>

                            <Button
                              className="d-flex align-items-center justify-content-center"
                              style={{ padding: '6px 14px' }}
                              size="sm"
                              color="primary"
                              onClick={handleApply}
                            >
                              <i className="ion-ios7-search font-20"></i>
                            </Button>

                            {showReset && (
                              <Button
                                className="d-flex align-items-center justify-content-center"
                                style={{ padding: '6px 13px' }}
                                size="sm"
                                color="danger"
                                onClick={handleReset}
                              >
                                <i className="mdi mdi-close font-20"></i>
                              </Button>
                            )}
                          </div>

                          <div
                            className="d-flex justify-content-start align-items-center"
                            style={{ gap: '10px' }}
                          ></div>
                        </div>

                        <div className="mt-4">
                          {summary && (
                            <TimeTrackingCard
                              summary={{
                                total: summary?.total,
                                tracked: summary?.tracked,
                                manuallyAdded: summary?.manuallyAdded,
                                idle: summary?.idle,
                                paidLeave: summary?.paidLeave,
                                break: summary?.break,
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card m-b-20">
                  <div className="card-body">
                    <div style={{ overflow: 'auto' }}>
                      <table
                        id="datatable"
                        className="table dt-responsive nowrap table-vertical"
                        width="100%"
                        cellSpacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Employee's Timezone</th>
                            <th>Mouse</th>
                            <th>Keyboard</th>
                            <th>Scroll</th>
                            <th>Project</th>
                            <th>Task</th>
                            {filts?.groupBy === 'TIME' ? (
                              <>
                                <th className="text-center">
                                  Activity start location
                                </th>
                                <th className="text-center">
                                  Connection Speed
                                </th>
                                <th>Description</th>
                              </>
                            ) : (
                              ''
                            )}
                            <th>App/Website</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {apiCalls ? (
                            activity?.activities?.length ? (
                              activity?.activities?.map((acts, idx) => {
                                return (
                                  <tr key={idx}>
                                    <td
                                      style={{
                                        whiteSpace: 'nowrap',
                                        fontSize: '15px',
                                      }}
                                    >
                                      {moment(acts?.startTime).format(
                                        'hh:mm A'
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        whiteSpace: 'nowrap',
                                        fontSize: '15px',
                                      }}
                                    >
                                      {moment(acts?.endTime).format('hh:mm A')}
                                    </td>
                                    <td>{acts?.timezone || 'N/A'}</td>
                                    <td>{acts?.mouseClick}</td>
                                    <td>
                                      <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                          handleData(acts?.keyPressed)
                                        }
                                      >
                                        {acts?.keystroke}
                                      </span>
                                    </td>
                                    <td>{acts?.scroll}</td>
                                    <td>
                                      <span>
                                        {acts?.projectTask?.project?.name ||
                                          'N/A'}
                                      </span>
                                    </td>
                                    <td>
                                      <span>
                                        {acts?.projectTask?.name || 'N/A'}
                                      </span>
                                    </td>
                                    {filts?.groupBy === 'TIME' ? (
                                      <>
                                        <td>
                                          <MapModal
                                            acts={{
                                              longitude: acts?.longitude,
                                              latitude: acts?.latitude,
                                              city: acts?.city,
                                            }}
                                          />
                                        </td>
                                        <td>
                                          {acts?.speed ? (
                                            <span className="text-nowrap">
                                              {(+acts?.speed / 1000000).toFixed(
                                                2
                                              )}{' '}
                                              Mbps
                                            </span>
                                          ) : (
                                            'N/A'
                                          )}
                                        </td>
                                        <td>
                                          <span>{acts?.description}</span>
                                        </td>
                                      </>
                                    ) : (
                                      ''
                                    )}
                                    <td>
                                      <span>
                                        {(acts?.appWebsites &&
                                          Array.isArray(acts?.appWebsites) &&
                                          acts?.appWebsites?.join('  , ')) ||
                                          '--'}
                                      </span>
                                    </td>
                                    <td>
                                      <span>
                                        <i
                                          className="fa fa-eye font-20"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => toggleModalEdit(acts)}
                                        ></i>

                                        <i
                                          className="fa fa-bar-chart-o font-20 ml-2"
                                          style={{ cursor: 'pointer' }}
                                          onClick={() =>
                                            toggleModalAppUsage(acts)
                                          }
                                        ></i>
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  colSpan={filts?.groupBy === 'TIME' ? 13 : 10}
                                  className="text-center"
                                >
                                  No Records Found
                                </td>
                              </tr>
                            )
                          ) : (
                            <tr>
                              <td
                                colSpan={filts?.groupBy === 'TIME' ? 13 : 10}
                                className="text-center"
                              >
                                Please click on the search button to get daily
                                activity stats
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AppsModals
          open={isEditOpen}
          onClose={toggleModalEdit}
          ID={appsData}
          filterBy={filts?.groupBy}
        />

        <AppsUsages
          open={isAppUsageOpen}
          onClose={toggleModalAppUsage}
          ID={appsData}
          filterBy={filts?.groupBy}
        />
      </AUX>
    </PageLoader>
  );
};

export default DailyActivity;
